export default {
    /**
     * @description 配置显示在浏览器标签的title
     * 组件命名：
     * 1、组件文件名：采用大驼峰（PascalCase）每个单词的首字母大写，如：MyComponent.vue
     * 2、基础组件：在组件文件名前加上Base前缀，如：BaseButton.vue
     * 3、父子组件：子组件文件名以父组件文件名为前缀，如：UserProfile.vue（父组件），UserProfileItem.vue（子组件）
     * 4、页面组件：使用短横线连接单词，如：user-profile.vue
     * 5、属性命名：使用小驼峰（camelCase）命名法，如：userName, isActive
     5、布局组件：在组件文件名前加上Layout前缀，如：LayoutMain.vue
     6、命名空间：使用文件夹结构来组织组件，如：components/forms/InputText.vue
     7、避免缩写：尽量避免使用缩写，保持名称清晰易懂，如：UserProfile而不是UsrPrfl
     8、一致性：在整个项目中保持命名规范的一致性，便于团队协作和代码维护
     */
    title: 'Luoli',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: true,
    /**
     * @description api请求基础路径
     */
    baseUrl: 'http://192.168.2.148:8090/',
  
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 需要加载的插件
     */

  }
  